var _BreadcrumbSkeleton, _SearchInputSkeleton, _MainCategoriesConten, _MainCategoriesConten2;
import { cx } from 'class-variance-authority';
import { BreadcrumbSkeleton, SearchInputSkeleton } from "../../../../../components";
import MainCategoriesContentSkeleton from "./MainCategoriesContentSkeleton";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var MainCategoriesCoursesViewSkeleton = function MainCategoriesCoursesViewSkeleton(_ref) {
  var className = _ref.className;
  return /*#__PURE__*/_jsxs("div", {
    className: cx('tw-pl-2 tw-pt-4.8', className),
    "data-testid": "main-categories-courses-view-skeleton",
    children: [_BreadcrumbSkeleton || (_BreadcrumbSkeleton = /*#__PURE__*/_jsx(BreadcrumbSkeleton, {
      className: "tw-mb-2"
    })), _SearchInputSkeleton || (_SearchInputSkeleton = /*#__PURE__*/_jsx(SearchInputSkeleton, {
      className: "tw-max-w-screen-sm tw-mx-2 md:tw-mx-auto tw-mb-3.2"
    })), _MainCategoriesConten || (_MainCategoriesConten = /*#__PURE__*/_jsx(MainCategoriesContentSkeleton, {
      className: "tw-mb-2"
    })), _MainCategoriesConten2 || (_MainCategoriesConten2 = /*#__PURE__*/_jsx(MainCategoriesContentSkeleton, {
      className: "tw-mb-2"
    }))]
  });
};
export default MainCategoriesCoursesViewSkeleton;